import styled from 'styled-components'
import MenuIcon from '@material-ui/icons/Menu';

import cross from 'images/cross.svg'
import crossDark from 'images/crossDark.svg'
import edit from 'images/edit.svg'


export const ClickableIcon = styled.img`
	:hover {
		opacity: 0.8;
		transform: scale(1.03);
	}
	transition: 200ms ease;
`

export const ClickableCross = styled(ClickableIcon).attrs({
	src: cross,
})``

export const ClickableCrossDark = styled(ClickableIcon).attrs({
	src: crossDark,
})``

export const ClickableEdit = styled(ClickableIcon).attrs({
	src: edit,
})``

export const Menu = styled(MenuIcon)`
	color: #346c84;
`
